import React from 'react';
import {
  Brain,
  Bot,
  PenTool,
  Laptop,
  Users,
  Sparkles,
} from 'lucide-react';
import '../CSS/Services.css';

const Services = () => {
  const services = [
    {
      icon: Brain,
      title: 'AI Consulting',
      description:
        'Strategic guidance to integrate AI into your business processes, identify opportunities, and develop AI roadmaps that drive growth.',
      features: [
        'AI Strategy Development',
        'Process Automation Planning',
        'Technology Assessment',
        'ROI Analysis',
      ],
      color: 'primary',
    },
    {
      icon: Bot,
      title: 'AI Agents & Automation',
      description:
        'Custom AI agents and automation workflows that handle repetitive tasks, streamline operations, and boost productivity.',
      features: [
        'Custom AI Agents',
        'Workflow Automation',
        'Integration Setup',
        'Performance Monitoring',
      ],
      color: 'secondary',
    },
    {
      icon: PenTool,
      title: 'Content Creation',
      description:
        'Tech and AI-focused content that educates, engages, and converts. From blog posts to video content and social media strategies.',
      features: [
        'Technical Writing',
        'Video Content',
        'Social Media Strategy',
        'Educational Materials',
      ],
      color: 'accent',
    },
    {
      icon: Laptop,
      title: 'SaaS & Tool Design',
      description:
        'End-to-end development of AI-powered SaaS applications and digital tools that solve real business problems.',
      features: [
        'MVP Development',
        'UI/UX Design',
        'Full-Stack Development',
        'Launch Strategy',
      ],
      color: 'primary',
    },
    {
      icon: Users,
      title: 'Team Training',
      description:
        'Comprehensive AI training programs for teams and organizations to maximize AI adoption and effectiveness.',
      features: [
        'Workshop Sessions',
        'Training Materials',
        'Best Practices',
        'Ongoing Support',
      ],
      color: 'secondary',
    },
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary':
        return {
          bg: 'rgba(63,142,252,0.1)',
          dot: '#3f8efc',
          iconBg: 'linear-gradient(135deg, #3f8efc, #1877f2)',
          iconShadow: '0 0 10px #3f8efc',
        };
      case 'secondary':
        return {
          bg: 'rgba(24,119,242,0.1)',
          dot: '#1877f2',
          iconBg: 'linear-gradient(135deg, #1877f2, #3f8efc)',
          iconShadow: '0 0 10px #1877f2',
        };
    
      default:
        return {
          bg: 'rgba(63,142,252,0.1)',
          dot: '#3f8efc',
          iconBg: 'linear-gradient(135deg, #3f8efc, #1877f2)',
          iconShadow: '0 0 10px #3f8efc',
        };
    }
  };

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="services-header">
          <div className="glass-pill text-muted select-none">
            <Sparkles size={16} className="sparkles-icon" />
            What I Offer
          </div>
          <h2 className="services-title">Transform Your Business with AI</h2>
        </div>

        <div className="services-grid">
          {services.map((service) => {
            const color = getColorClasses(service.color);
            return (
              <div
                key={service.title}
                className="service-card"
                style={{
                  backgroundColor: '#fff', // White background for card
                  borderColor: color.dot,
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                }}
              >
                {/* Icon and Title on same line */}
<div className="service-header-flex">
  <div
    className="service-icon"
    style={{
      backgroundImage: color.iconBg,
      boxShadow: color.iconShadow,
      color: 'white',
    }}
  >
    <service.icon size={28} />
  </div>
  <h3 className="service-title" style={{ color: color.dot }}>
    {service.title}
  </h3>
</div>


                <p className="service-desc">{service.description}</p>

                <ul className="service-features">
                  {service.features.map((feat, i) => (
                    <li
                      key={i}
                      className="feature-item"
                      style={{ '--dot-color': color.dot }}
                    >
                      <span className="feature-dot" />
                      {feat}
                    </li>
                  ))}
                </ul>

                {/* <button
                  className="learn-more-btn"
                  type="button"
                  aria-label={`Learn more about ${service.title}`}
                >
                  Learn More <ArrowRight size={16} className="arrow-icon" />
                </button> */}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
